import axios, { AxiosResponse } from 'axios';
import {
  LogsModel,
  ReservationDetailViewModel,
  ReservationEditRequest,
  ReservationFilters,
  ReservationModel
} from './reservation.types';
import {
  defaultPageSize,
  FILTER_DATE_TIME_FORMAT,
  GatewayResponse,
  Page,
  PageRequest,
  RevisionModel
} from '../api.types';

const FRONT_END_SERVER_API_URL = window.config.apiUrls.frontendServerApi;

const listAllReservations = async (filters?: ReservationFilters, pageRequest?: PageRequest) => {
  const { data }: AxiosResponse<GatewayResponse<Page<ReservationModel>>> = await axios.get(
    `${FRONT_END_SERVER_API_URL}/:supplier/reservation/reservations`,
    {
      params: {
        combinedFilterField: filters ? filters.combinedFilterField : undefined,
        brokerId: filters ? filters.brokerId : undefined,
        brokerRateCode: filters ? filters.brokerRateCode : undefined,
        reservationStatus: filters ? filters.reservationStatus : undefined,
        pickupDeskCodes: filters ? filters.pickupDeskCodes : undefined,
        date: filters ? filters.date : undefined,
        creationTimeStart: filters && filters.reservationsBetween.from ? filters.reservationsBetween.from.format(FILTER_DATE_TIME_FORMAT) : undefined,
        creationTimeEnd: filters && filters.reservationsBetween.to ? filters.reservationsBetween.to.format(FILTER_DATE_TIME_FORMAT) : undefined,
        page: pageRequest ? pageRequest.page : undefined,
        size: defaultPageSize
      }
    }
  );

  return data;
};

const getOneReservation = async (reservationNumber: string, uuid?: string, supplier?: string) => {
  if (uuid) {
    const { data }: AxiosResponse<GatewayResponse<ReservationModel>> = await axios.get(
      `${FRONT_END_SERVER_API_URL}/public/${supplier}/reservations/${reservationNumber}`,
      {
        params: {
          uuid
        }
      }
    );

    return data;
  }

  const { data }: AxiosResponse<GatewayResponse<ReservationModel>> = await axios.get(
    `${FRONT_END_SERVER_API_URL}/:supplier/reservation/reservations/${reservationNumber}`
  );

  return data;
};

const patchReservation = async (reservationNumber: string, request: ReservationEditRequest, uuid?: string, supplier?: string) => {
  if (uuid) {
    const { data }: AxiosResponse<GatewayResponse<ReservationModel>> = await axios.patch(
      `${FRONT_END_SERVER_API_URL}/public/${supplier}/reservations/${reservationNumber}`,
      request,
      {
        params: {
          uuid
        }
      }
    );

    return data;
  }

  const { data }: AxiosResponse<GatewayResponse<ReservationModel>> = await axios.patch(
    `${FRONT_END_SERVER_API_URL}/:supplier/reservation/reservations/${reservationNumber}`,
    request
  );

  return data;
};

const getReservationRevisions = async (reservationNumber: string) => {
  const { data }: AxiosResponse<GatewayResponse<RevisionModel[]>> = await axios.get(
    `${FRONT_END_SERVER_API_URL}/:supplier/reservation/reservations/${reservationNumber}/revisions`
  );

  return data;
};

const getReservationDetails = async (reservationNumber: string, uuid?: string, supplier?: string) => {
  if (uuid) {
    const { data }: AxiosResponse<GatewayResponse<ReservationDetailViewModel>> = await axios.get(
      `${FRONT_END_SERVER_API_URL}/public/${supplier}/reservations/${reservationNumber}`,
      {
        params: {
          uuid
        }
      }
    );

    return data;
  }

  const { data }: AxiosResponse<GatewayResponse<ReservationDetailViewModel>> = await axios.get(
    `${FRONT_END_SERVER_API_URL}/:supplier/reservation/reservations/${reservationNumber}/view`
  );

  return data;
};

const getReservationLogs = async (reservationNumber: string, type: string) => {
  const { data }: AxiosResponse<GatewayResponse<LogsModel>> = await axios.get(
    `${FRONT_END_SERVER_API_URL}/:supplier/reservation/reservations/${reservationNumber}/logs?logType=${type}`
  );

  return data;
};


export const reservationApi = {
  Reservations: {
    listAllReservations,
    getOneReservation,
    patchReservation,
    getReservationDetails,
    getReservationLogs,
    getReservationRevisions
  }
};
